<template>
<div class="content">
  <img @click="goPage" src="../../assets/comback_f.png" class="comback" />
  <!--    视频-->
  <div class="lp-player-box">
    <video id="video"
           ref="myVideo"
           :poster="video_cover"
           :src="video_src" preload="auto" webkit-playsinline="true" playsinline="true" x-webkit-airplay="allow" x5-video-player-type="h5"
           x5-video-player-fullscreen="true" x5-video-orientation
           class="video-box" loop @click="isPlay"
    ></video>
  </div>
  <!-- 封面 -->
  <!--    <img v-show="isVideoShow" class="play" @click="playvideo" :src="video_cover"/>-->
  <!-- 播放暂停按钮 -->
  <!--    <img v-show="iconPlayShow" class="icon_play" @click="playvideo"-->
  <!--         src="http://npjy.oss-cn-beijing.aliyuncs.com/images/file-1575340653940esdHR.png"/>-->
<!--  <div v-show="iconPlayShow" class="lp-player-btn" v-if="video_is_show" @click="playvideo">-->
<!--    <van-icon size="50" name="play-circle-o" />-->
<!--  </div>-->
  <!-- 自定义进度条 -->

  <!-- 播放按钮 -->
  <div class="lp-player-btn" v-if="video_is_show" @click="isPlay">
    <van-icon size="50" name="play-circle-o" />
  </div>
  <div class="title-box">
    <div class="title-box-top justify-align">
      <span></span>
      <div class="share-box">
        <div class="share-item">
          <img src="../../assets/f_share.png" alt="">
          {{live_info.show}}
        </div>
        <div class="share-item">
          <img src="../../assets/f_aixin.png" alt="">
          {{live_info.likes}}
        </div>
      </div>
    </div>
    <div class="title">{{video_title}}</div>
    <div class="trailer_progress_bar">
      <div class="proress_content_box">
        <p class="pro_pone">{{ this.currentTime }}</p>
        <div
          ref="progress"
          class="progress_bar_box"
          @mousedown="getNowWh($event)"
          @mouseup="mouseup($event)"
        >
          <div
            ref="onProgress"
            :class="[ radiusLeft ? 'on_progress_bar_child border_Radius' : 'on_progress_bar_child',]">
            <span
              v-show="!radiusLeft"
              ref="mouseDom"
              class="mouse_down"
              @mousedown.stop="mousedown($event)"
              @mouseup.stop="mouseup($event)"
            ></span>
          </div>
        </div>
        <p class="pro_pone">{{ this.duration }}</p>
      </div>
    </div>
    <!-- end -->
  </div>

</div>
</template>

<script>
import { factoryDes } from '@/api/factory'
export default {
  name: "factoryDes",
  data () {
    return {
      video_cover: require('@/assets/07hot1.png'),
      activeNav: 0,
      video_src:'',
      video_title:'',
      live_id:'',
      live_info:'',
      video_is_show:false,
      playOrPause: true,
      iconPlayShow: true,
      currentTime: "00:00", //当前时间
      duration: "00:00", //总时长
      pvideo: null, //视频容器
      timer: null, //定时器
      radiusLeft: false,
    }
  },
  mounted(){
    var that = this
    // let video = document.getElementById('video')
    this.pvideo = document.getElementById('video')

  },
  created() {
    this.live_id = this.$route.query.id
    this.getDes()
  },
  methods: {
    //初始化事件
    init() {
      this.pvideo = document.getElementById('video')
      this.isPlay();
    },
    //播放
    isPlay() {
      if (this.pvideo.paused || this.pvideo.ended) {
        this.pvideo.play();
        this.timer = setInterval(this.setProgress, 60);
        this.video_is_show = false
      } else {
        console.log('暂停')
        this.pvideo.pause();
        clearInterval(this.timer);
        this.timer = null;
        this.video_is_show = true
      }
    },
    //设置进度条
    setProgress() {
      let progress = this.$refs.progress; //获取进度条父元素
      let onProgress = this.$refs.onProgress; //获取变化进度条的元素
      let mouseDom = this.$refs.mouseDom;
      console.log(mouseDom)
      this.currentTime = this.timeFomat(this.pvideo.currentTime); //当前播放的时间,格式化时间格式后展示
      this.duration = this.timeFomat(this.pvideo.duration); //总时长，格式化时间格式后展示
      //换算,视频没有结束或者被暂停
      if (!this.pvideo.ended) {
        this.radiusLeft = false;
        let percent = this.pvideo.currentTime / this.pvideo.duration; //得出比例
        mouseDom &&
        (mouseDom.style.left = percent * progress.offsetWidth + "px");
        onProgress &&
        (onProgress.style.width = percent * progress.offsetWidth + "px");
      } else {
        //视频已结束
        onProgress && (onProgress.style.width = "100%");
        this.radiusLeft = true;
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    //点击当前位置，设置进度条
    getNowWh(event) {
      let ev = event || window.event;
      this.videoSeek(ev.offsetX);
    },
    //传入当前点击的偏移量，换算当前视频时间，并播放
    videoSeek(startx) {
      if (this.pvideo.paused || this.pvideo.ended) {
        this.pvideo.play();
        this.enhanceVideoSeek(startx);
      } else {
        this.enhanceVideoSeek(startx);
      }
    },
    //根据鼠标拖动的距离，换算进度条
    enhanceVideoSeek(moveWidth) {
      clearInterval(this.timer);
      let progress = this.$refs.progress; //获取进度条父元素
      let onProgress = this.$refs.onProgress; //获取变化进度条的元素
      let percent = moveWidth / progress.offsetWidth;
      onProgress &&
      (onProgress.style.width = percent * progress.offsetWidth + "px");
      this.pvideo.currentTime = percent * this.pvideo.duration;
      this.timer = setInterval(this.setProgress, 60);
    },
    vueTouch:function(s,e){
      console.log(s,e)
    },
    //鼠标按下
    mousedown(event) {
      console.log(event)
      let that = this;
      let ev = event || window.event;
      let _target = ev.target;
      let startx = ev.clientX;
      let sb_bkx = startx - ev.target.offsetLeft;
      let allwh = this.$refs.progress.clientWidth;
      let ww = document.documentElement.clientWidth;
      let wh = window.innerHeight;
      //阻止事件冒泡
      if (ev.preventDefault) {
        ev.preventDefault();
      } else {
        ev.returnValue = false;
      }
      //移动
      document.onmousemove = function (ev) {
        let evt = ev || window.event;
        let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
        if (
          evt.clientY < 0 ||
          evt.clientX < 0 ||
          evt.clientY > wh ||
          evt.clientX > ww
        ) {
          return false;
        }


        let endx = evt.clientX - sb_bkx;
        //设置拖动有效区域
        if (endx > -1 && endx < allwh) {
          _target.style.left = endx + "px";
          that.enhanceVideoSeek(endx);
        } else {
          //超出区域，置空拖动事件
          document.onmousemove = null;
        }
      };
    },
    //鼠标放开
    mouseup(e) {
      document.onmousemove = null;
    },
    //订阅暂停事件
    stopPlay() {
      Watcher.$on("stop", (data) => {
        this.isPlay();
      });
    },
    /* 时间格式化 */
    timeFomat(time) {
      let h = Math.floor(time / 3600);
      let m = Math.floor((time % 3600) / 60);
      let s = Math.floor(time % 60);
      m = m >= 10 ? m : "0" + m;
      s = s >= 10 ? s : "0" + s;
      if (h === 0) {
        return m + ":" + s;
      }
      return h + ":" + m + ":" + s;
    },
    goPage(){
      this.$router.go(-1)
    },
    play(){
      video.play();
      this.video_is_show = false
    },
    getDes(){
      factoryDes(this.live_id).then(res => {
        if(res.code == 200)
        {
          console.log('res',res.data)
          this.live_info = res.data
          this.video_src = res.data.video_url
          this.video_cover = res.data.image
          this.video_title = res.data.title
          // video.play();
          setTimeout(() => {
            //通知父组件关闭
            console.log('播放')
            this.init();

          }, 1000);

        }
        else
        {
          this.$toast(res.message)
          this.$router.push('/');
        }
      })
    },
  }

}
</script>

<style lang="scss" scoped>

.content{
  position: relative;
}
.comback{
width: 54px;height: auto;display: block;left: 30px; top: 30px;z-index: 22;position: absolute;
}
.title-box{

  background: linear-gradient(transparent, #000);
  width: 100%;
  position: absolute;
  right: 0;
  bottom: 0;
  color: #fff;padding: 30px 0;z-index: 22;
  .title-box-top{
    padding: 10px 20px;
    .share-box{
      display: inline-block;
    }
    .share-item{
    text-align: center;display: inline-block;margin-left: 30px;
      img{
        width: 50px;display: block;height: auto;
      }
    }
  }
}
.title{
  font-size: 26px;color: #FFFFFF;line-height: 45px;text-align: left;padding: 20px 20px;
}
.lp-player-btn{
  position: absolute;
  width: 100%;
  height: 100vh;
  z-index: 999;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 50px;
  color: #fff;
  background: rgba(0,0,0,.3);top: 0;
}
.lp-player-box{
  position: relative;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  .video-box{
    z-index: 1;
    position: absolute;
    width: 100%;
    height: 100vh;left: 0;
    object-fit: cover;top: 0;
  }
  .player{
    z-index: 1;
    position: absolute;
    width: 100%;
    height: 100vh;
    object-fit: fill;left: 0;top: 0;
  }
}
.trailer_video_box {
  width: 100%;
  height: calc(100% - 100px);
  position: absolute;
  top: 8px;
  left: 0;
  z-index: 1000;
  background: #292c32;
  border-radius: 12px;
  .trailer_box {
    width: 100%;
    height: calc(100% - 143px);
    padding: 0;
    object-fit: initial;
    border-radius: 12px 12px 0 0;
  }

}
.trailer_progress_bar {
  //width: 100%;
  padding: 0 10px;
  overflow: hidden;
  position: relative;
  .proress_title {
    width: 100%;
    height: 100px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 32px;
      height: 32px;
      margin-right: 8px;
    }
    p {
      color: #fff;
      font-size: 12px;
      font-weight: 600;
    }
  }
  .proress_content_box {
    width: 100%;
    overflow: hidden;
    display: flex;
    //padding: 0 24px;
    justify-content: center;
    p {
      color: #fff;
      font-weight: 400;
      font-size: 24px;margin: 0;
    }
    .pro_pone {
    }
    .progress_bar_box {
      flex: 0.9;
      margin: 6px 16px 0 16px;
      height: 8px;
      background: rgba(205, 206, 209, 0.2);
      border-radius: 5px;
      box-sizing: border-box;
      position: relative;
      .on_progress_bar_child {
        width: 0;
        height: 100%;
        background: #cdced1;
        border-radius: 4px 0px 0px 4px;
        // overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1001;
        .mouse_down {
          position: absolute;
          width: 5px;
          height: 16px;
          top: 50%;
          margin-top: -8px;
          left: 100%;
          background: #ff5001;
          border-radius: 3px;
          z-index: 1002;
          cursor: pointer;
        }
      }
      .on_progress_bar_child.border_Radius {
        border-radius: 4px;
      }
    }
  }
}
</style>
